import React from 'react';
import AdBanner from '../components/AdBanner';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-10 md:py-16">
      <SEO
        title="Privacy Policy | Nath Nagri Bareilly"
        description="Privacy Policy for Nath Nagri Bareilly. Learn about how we collect, use, and protect your data."
        keywords="privacy policy, data collection, cookies, adsense privacy"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center md:text-left">
          <h1 className="text-4xl font-extrabold text-stone-900 mb-4">Privacy Policy (गोपनीयता नीति)</h1>
          <p className="text-lg text-stone-600">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main Content (Left) */}
          <div className="flex-1 bg-white p-8 rounded-2xl border border-stone-100 shadow-sm prose prose-lg prose-stone max-w-none [&>p]:mb-6 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-4 [&>h3]:mt-8">
            <p>
              At <strong>Nath Nagri Bareilly</strong> ("we", "us", or "our"), accessible from nathnagribareilly.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by us and how we use it.
            </p>

            <h3>1. Information We Collect</h3>
            <p>
              We only collect information that is explicitly provided by you (such as your name and email when using our contact form or commenting system) and standard analytical data that your web browser routinely shares (such as IP addresses, browser types, Internet Service Providers (ISP), referring/exit pages, and click data).
            </p>
            <p>
              This analytical information is NOT directly linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, and understanding our demographic user base.
            </p>

            <h3>2. Cookies and Web Beacons</h3>
            <p>
              Like any other website, Nath Nagri Bareilly uses "cookies". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
            </p>

            <h3>3. Google DoubleClick DART Cookie & AdSense</h3>
            <p>
              Google is one of the third-party vendors on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to our site and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">https://policies.google.com/technologies/ads</a>.
            </p>
            <p>
              Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Nath Nagri Bareilly, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
            </p>
            <p>
              <em>Note that Nath Nagri Bareilly has no access to or control over these cookies that are used by third-party advertisers.</em>
            </p>

            <h3>4. Third Party Privacy Policies</h3>
            <p>
              Nath Nagri Bareilly's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
            </p>
            <p>
              You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
            </p>

            <h3>5. User Privacy Rights (GDPR / CCPA)</h3>
            <p>
              We want to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
            </p>
            <ul>
              <li><strong>The right to access</strong> – You have the right to request copies of your personal data.</li>
              <li><strong>The right to rectification</strong> – You have the right to request that we correct any information you believe is inaccurate.</li>
              <li><strong>The right to erasure</strong> – You have the right to request that we erase your personal data, under certain conditions.</li>
            </ul>
            <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us at info@nathnagribareilly.com.</p>

            <h3>6. Consent</h3>
            <p>
              By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.
            </p>
          </div>

          {/* Sidebar (Right) */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <AdBanner placement="sidebar" pageName="privacy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
